module.exports = __webpack_public_path__ + "img/AMWETCarousel_lowerBack.f1e7d914.jpg";